import { svgIconFactory } from './icon-factory';

function Email() {
  return (
    <svg width="26px" height="26px" viewBox="0 0 26 26" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>icon/mail</title>
      <desc>Created with Sketch.</desc>
      <g id="icon/mail" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path
          d="M22.0999822,0 L3.90001777,0 C1.69002209,0 0,1.6899967 0,3.90001777 L0,22.0999822 C0,24.3099779 1.6899967,26 3.90001777,26 L22.0999822,26 C24.3099779,26 26,24.3100033 26,22.0999822 L26,3.90001777 C26,1.69002209 24.3100033,0 22.0999822,0 Z"
          id="路径"
          fill="#FFFFFF"
          fillRule="nonzero"
        ></path>
        <path
          d="M20.8647064,7 L6.13511963,7 C5.50883532,7 5,7.55557443 5,8.24050965 L5,18.7594904 C5,19.445609 5.50827384,20 6.13511963,20 L20.8647064,20 C21.4911458,20 22,19.4444049 22,18.7594904 L22,8.24050965 C22,7.55434765 21.4917262,7 20.8647064,7 Z M18.878897,11.4409275 L13.8018869,14.6431627 C13.7233039,14.7163079 13.62257,14.7550257 13.5204631,14.753208 C13.4183748,14.7550255 13.3176795,14.7163079 13.239077,14.6431627 L8.16204807,11.4409275 C7.95852907,11.3127701 7.8879746,11.0304389 8.00613953,10.8067568 C8.12358833,10.5848901 8.38230145,10.5075186 8.58705686,10.6368808 L13.5204625,13.7484503 L18.4539059,10.6368808 C18.6586424,10.5075188 18.9173554,10.5848909 19.034689,10.8067568 C19.1531052,11.0304409 19.0822798,11.3127707 18.8788968,11.4409275 L18.878897,11.4409275 Z"
          id="形状"
          fill="#302B3C"
          fillRule="nonzero"
        ></path>
      </g>
    </svg>
  );
}

export const EmailIcon = svgIconFactory(Email);
